<template>
  <v-container class="pa-6 pa-lg-12 fill-height align-start" fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-space-between align-center py-0">
        <div class="d-flex align-center">
          <span class="headline mr-4">{{ $t("labelsLabel") }}</span>
          <v-btn
            small
            depressed
            color="primary"
            @click="showLabelCreationForm = true"
          >
            <v-icon left>mdi-plus</v-icon> {{ $t("createLabel") }}
          </v-btn>
        </div>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-data-table
          :options.sync="options"
          :footer-props="labels.footerProps"
          :server-items-length="1"
          :page.sync="page"
          :items-per-page="amount"
          class="mb-5 mt-4"
          :hide-header="true"
          :headers="labels.headers"
          :items="labels.values"
          :loading="loading"
          :loading-text="$t('tableLoadingLabel')"
        >
          <template #item.actions="{ item }">
            <div class="d-flex">
              <v-btn
                icon
                color="primary"
                class="mr-2"
                outlined
                x-small
                fab
                dark
                @click="updateLabelEventHandler(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                icon
                outlined
                x-small
                fab
                dark
                color="red"
                @click="deleteLabelEventHandler(item)"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:no-data>
            {{$t('noDataAvailable')}}
          </template>
          <template v-slot:no-results>
            {{$t('noDataAvailable')}}
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="pageCount"
          total-visible="20"
          @input="fetchLabels()"
        ></v-pagination>
      </v-col>
    </v-row>
    <!-- Create label  -->
    <v-dialog v-model="showLabelCreationForm" max-width="700px">
      <v-card class="pa-10">
        <v-card-title class="justify-center">
          {{ $t("createLabel") }}
        </v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                outlined
                hide-details
                :label="$t('labelNameLabel')"
                v-model="labelName"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                dense
                outlined
                hide-details
                no-resize
                :label="$t('labelTextLabel')"
                v-model="labelText"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-row>
            <v-col cols="12" md="6">
              <v-btn
                width="100%"
                small
                depressed
                color="primary"
                :disabled="!isCreateLabelFormValid"
                @click="createLabel"
              >
                {{ $t("saveDataLabel") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="6">
              <v-btn
                small
                width="100%"
                color="red white--text"
                @click="showLabelCreationForm = false"
              >
                {{ $t("cancelLabel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Update level label sheet -->
    <v-dialog v-model="updateLabelSheet" max-width="500px">
      <v-card class="pa-10">
        <v-card-title class="justify-center">
          {{ $t("updateLabel") }}
        </v-card-title>
        <v-card-text class="pa-0">
          <v-container>
            <v-row>
              <v-col cols="12">
                <div class="text-caption">{{$t('labelNameLabel')}}</div>
                <div class="text-subtitle-2 black--text">
                    {{selectedLabel.name}}
                </div>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  outlined
                  :label="$t('labelTextLabel')"
                  v-model="selectedLabel.text"
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col cols="6">
              <v-btn
                width="100%"
                depressed
                small
                color="primary"
                class=""
                @click="updateLabel"
              >
                {{ $t("saveDataLabel") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                width="100%"
                small
                class="mr-2"
                color="red white--text"
                @click="updateLabelSheet = false"
              >
                {{ $t("cancelLabel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-bottom-sheet v-model="updateLabelSheet">
      <v-sheet class="py-4 text-center">
        <v-row no-gutters justify="center" class="py-3">
          <v-col cols="12" md="6" lg="5">
            <v-text-field
              dense
              outlined
              label="Name"
              v-model="selectedLabel.name"
            ></v-text-field>
            <v-textarea
              dense
              outlined
              label="Text"
              v-model="selectedLabel.text"
            ></v-textarea>
            <div class="d-flex">
              <v-btn
                depressed
                small
                color="primary"
                class="mx-auto"
                @click="updateLabel"
                >Update</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn text small color="red" @click="updateLabelSheet = false"
                >Close</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-sheet>
    </v-bottom-sheet> -->
    <!-- Delete level bottom sheet -->
    <v-dialog v-model="deleteLabelSheet" max-width="500px">
      <v-card class="pa-10">
        <v-card-title class="justify-center">{{
          $t("deleteLabelTitle")
        }}</v-card-title>
        <p class="text-center">{{ $t("deleteLabelDescription") }}</p>

        <v-card-actions>
          <v-row>
            <v-col cols="6">
              <v-btn width="100%" small color="primary" @click="deleteLabel"
                >OK</v-btn
              >
            </v-col>
            <v-col cols="6">
              <v-btn
                width="100%"
                small
                color="red white--text"
                @click="deleteLabelSheet = false"
              >
                {{ $t("cancelLabel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-bottom-sheet v-model="deleteLabelSheet">
      <v-sheet class="text-center py-4">
        <div class="py-3">Are you sure you want to delete this label?</div>
        <v-btn text color="red" @click="deleteLabel">Yes</v-btn>
        <v-btn text color="primary" @click="deleteLabelSheet = false">No</v-btn>
      </v-sheet>
    </v-bottom-sheet> -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "labels",
  data(){ 
    return {
      options: {},
      loading: false,
      page: 1,
      pageCount: 1,
      amount: 10,
      itemsPerPage: 1,
      sortBy:'',
      sortDesc: null,
      labels: {
        search: "",
        headers: [
          {
            text: this.$t('labelNameLabel'),
            value: "name",
            width: "45%",
          },
          {
            text: this.$t('labelTextLabel'),
            value: "text",
            width: "45%",
          },
          {
            text: this.$t('actionsLabel'),
            width: "10%",
            value: "actions",
            sortable: false
          },
        ],
        values: [],
        footerProps:{
          'items-per-page-options' : [5, 10, 15, 20, -1],
          'disable-pagination': true,
          'next-icon': null,
          'prev-icon': null,
          'page-text' : '',
          'items-per-page-all-text': this.$t('allLabel'),
          'items-per-page-text': this.$t('rowsPerPageLabel')
        }
      },
      filterLabelByName: "",
      labelName: "",
      labelText: "",
      labelLanguageId: null,
      selectedLabel: {},
      snackbar: {
        show: true,
        message: "",
      },
      updateLabelSheet: false,
      deleteLabelSheet: false,
      showLabelCreationForm: false,
      requesting: false,
      loadingMore: false,
      hideShowMore: false,
    }
  },
  computed: {
    ...mapGetters(["getCurrentUser"]),
    isCreateLabelFormValid() {
      return this.labelName && this.labelText;
    },
  },
  mounted() {    
    this.fetchLabels();
  },
  watch: {
    options: {
      handler(){
        const options = this.options;
        this.amount = options.itemsPerPage
        const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : '';
        const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
        this.sortBy = sortBy;
        this.sortDesc = sortDesc;
        this.fetchLabels();
      },
      deep: true
    }
  },
  methods: {
    async fetchLabels() {
      this.loading = true;
      await this.axios
        .get("/api/label/getallwithpagination", {
          params: {
            languageId: 1,
            amount: this.amount,
            page: this.page,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc
          },
        })
        .then((response) => {
          console.log(response.data);
          this.pageCount = response.data.pages;
          this.labels.values = response.data.labels;
          // this.reviewsOffset = response.data.offset
          this.loading = false;
        })
        .catch((error) => {
          this.snackbar.message = error.message;
          this.$EventBus.$emit("snackbar", this.snackbar);
          this.loading = false;
        });
    },
    filterLabelsEventHandler() {
      this.reviewsOffset = 0;
      this.amount = 999;
      this.hideShowMore = true;
      this.labels = [];
      this.fetchLabels();
    },
    resetLabels() {
      this.reviewsOffset = 0;
      this.amount = 10;
      this.filterLabelByName = "";
      this.hideShowMore = false;
      this.labels = [];
      this.fetchLabels();
    },
    createLabel() {
      const data = {
        name: this.labelName,
        text: this.labelText,
        languageId: 1,
      };
      this.axios
        .post("/api/label/create", data)
        .then((response) => {
          this.labels.values.push(response.data);
          this.showLabelCreationForm = false;
          this.labelName = "";
          this.labelText = "";
            this.snackbar.message = this.$t("labelCreatedLabel")
            this.$EventBus.$emit("snackbar", this.snackbar);
        })
        .catch((error) => {
            this.snackbar.message = error.message
            this.$EventBus.$emit("snackbar", this.snackbar);

        });
    },
    updateLabelEventHandler(label) {
      this.selectedLabel.id = label.id;
      this.selectedLabel.name = label.name;
      this.selectedLabel.text = label.text;
      this.selectedLabel.languageId = label.languageId;
      this.updateLabelSheet = true;
    },
    updateLabel() {
      const data = {
        id: this.selectedLabel.id,
        name: this.selectedLabel.name,
        text: this.selectedLabel.text,
        languageId: this.selectedLabel.languageId,
      };
      this.axios
        .put("/api/label/update", data)
        .then((response) => {
          // this.fetchLabels();
          // this.snackbar.message = 'Label Updated!'
          // this.$EventBus.$emit('snackbar', this.snackbar)
          let index = this.labels.values
            .map((label) => {
              return label.id;
            })
            .indexOf(this.selectedLabel.id);
          console.log(response);
          this.labels.values[index].name = response.data.name;
          this.labels.values[index].text = response.data.text;
          this.updateLabelSheet = false;
          this.snackbar.message = this.$t("labelUpdatedLabel");
          this.$EventBus.$emit("snackbar", this.snackbar);
        })
        .catch((error) => {
            this.snackbar.message = error.message
            this.$EventBus.$emit("snackbar", this.snackbar);

        });
    },
    deleteLabelEventHandler(label) {
      this.selectedLabel.id = label.id;
      this.selectedLabel.languageId = label.languageId;
      this.deleteLabelSheet = true;
    },
    deleteLabel() {
      this.axios
        .delete("api/label/delete", {
          params: {
            id: this.selectedLabel.id,
            languageId: this.selectedLabel.languageId,
          },
        })
        .then((response) => {
          let index = this.labels.values
            .map((label) => {
              return label.id;
            })
            .indexOf(this.selectedLabel.id);
          this.labels.values.splice(index, 1);
          this.selectedLabel = {};
          this.deleteLabelSheet = false;
            this.snackbar.message = this.$t("labelDeletedLabel");
            this.$EventBus.$emit("snackbar", this.snackbar);
        })
        .catch((error) => {
            this.snackbar.message = error.message
            this.$EventBus.$emit("snackbar", this.snackbar);
        });
    },
    getLanguageById(id) {
      let index = this.languages
        .map((language) => {
          return language.id;
        })
        .indexOf(id);
      return this.languages[index].label;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>